<p><span>{{attribute.key}}: </span> {{attribute.value}}</p>